import { Button, FormGroup, Input, Label, Select } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { useEffect, useRef, useState } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { useLocation, useNavigate } from 'react-router-dom'
import commonUtils from '@/utils/commonUtils'
import { useRedis } from '@/hooks/useRedis'
import { useLog } from '@/hooks/useLog'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

interface DataRow {
  cmpnyCd: string
  surveySn: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  surveyTitle: string
  surveyDesc: string
  surveyStartDate: string
  surveyEndDate: string
  isAnonymous: string
  isMultiple: string
  maxChoices: string
  useYn: string
  useYnNm: string
  delYn: string
  delYnNm: string
  count: number
}

const ComSurvey: React.FC = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState<DataRow[]>([]);
  const [totalCnt, setTotalCnt] = useState(0);

  const { getComCodes, getComCodeValue } = useRedis();

  const {insertLog} = useLog();

  // const [currentPage, setCurrentPage] = useState(location.state?.page || 1);
  const currentPage = useRef(location.state?.page || 1);
  const perPage = useRef(location.state?.perPage || 10);
  const today = new Date();
  const before1Month = new Date();
  before1Month.setMonth(today.getMonth() - 1);
  const [searchData, setSearchData] = useState<DataRow>(
    location.state?.searchData || {
      cmpnyCd: '',
      surveySn: '',
      regId: '',
      regDate: '',
      updId: '',
      updDate: '',
      surveyTitle: '',
      surveyDesc: '',
      surveyStartDate: '',
      surveyEndDate: '',
      isAnonymous: '',
      isMultiple: '',
      maxChoices: '',
      useYn: '',
      useYnNm:'',
      delYn: '',
      delYnNm: '',
      count: -1
    },
  )

  const columns: TableColumn<DataRow>[] = [
    // {
    //   name: 'No.',
    //   selector: (row) => row.rnum,
    //   sortable: true,
    //   center: true,
    //   wrap: true,
    // },
    {
      name: '투표번호',
      selector: (row) => row.surveySn,
      sortable: true,
      wrap: true,
      width: '8%',
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.surveySn}</div>
      ),
    },
    {
      name: '투표제목',
      selector: (row) => row.surveyTitle,
        // commonUtils.formatDate(row.logDate + row.logTime, true),
      sortable: true,
      center: true,
      wrap: true,
      width: '30%',
    },
    {
      name: '투표건수',
      selector: (row) => row.count.toLocaleString(),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '투표시작일',
      selector: (row) => commonUtils.formatDate(row.surveyStartDate, false),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '투표종료일',
      selector: (row) => commonUtils.formatDate(row.surveyEndDate, false),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '사용여부',
      selector: (row) => row.useYnNm || row.useYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '6%',
    },
    {
      name: '삭제여부',
      selector: (row) => row.delYnNm || row.delYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '6%',
    },
    {
      name: '수정자',
      selector: (row) => row.updId,
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '수정일시',
      selector: (row) => commonUtils.formatDate(row.updDate, false),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '',
      cell: (row) => (
        <>
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleButtonUpdateClick(row.surveySn)}
          >
            상세
          </Button>
        </>
      ),
      sortable: false,
      width: '10%',
    },
  ]

  const handleButtonUpdateClick = async (surveySn: string) => {
    navigate(`/survey/detail`, {
      state: {
        surveySn: surveySn,
        searchData: searchData,
      },
    })
  }

  const getComSurveyList = async () => {
    try {
      // if(commonUtils.isYYYYMMDD(searchData.surveyStartDate)){
      //   setSearchData({
      //     ...searchData,
      //     surveyStartDate: searchData.surveyStartDate+'000000'
      //   })
      // }
      // if(commonUtils.isYYYYMMDD(searchData.surveyEndDate)){
      //   setSearchData({
      //     ...searchData,
      //     surveyEndDate: searchData.surveyEndDate+'235959'
      //   })
      // }

      const response = await axios.post('/survey/list', {...searchData,
        surveyStartDate : commonUtils.isYYYYMMDD(searchData.surveyStartDate) ? searchData.surveyStartDate.replaceAll('-', '')+'000000' : searchData.surveyStartDate,
        surveyEndDate : commonUtils.isYYYYMMDD(searchData.surveyEndDate) ? searchData.surveyEndDate.replaceAll('-', '')+'235959' : searchData.surveyEndDate
      });

      const listData:DataRow[] = response.data.data.list;
      if (Array.isArray(listData)) {
        for(const data of listData){
          data.useYnNm = getComCodeValue('USE_YN', data.useYn)?.codeNm || '';
          data.delYnNm = getComCodeValue('DEL_YN', data.delYn)?.codeNm || '';
        }
        setData(listData);
      }
      // setTotalCnt(response.data.data.totalCnt);
    } catch (error:any) {
      insertLog({
        logMsg: error.message,
        stackTrace: error.stack,
        remarks : 'call api /log/list',
      });
    }
  }

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    setSearchData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      } as DataRow // 모든 필드를 포함하는 상태를 유지
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  }

  const handleSearch = () => {
    getComSurveyList();
  };


  useEffect(() => {
    getComSurveyList();
  }, [])

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>투표관리</p>
        <div style={{ marginLeft: 'auto' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <FormGroup>
              <Label htmlFor={'surveyStartDate'}>조회시작일</Label>
              <FlexWrapper>
                <Input
                  placeholder="YYYYMMDD"
                  id="surveyStartDate"
                  name="surveyStartDate"
                  type='date'
                  value={searchData.surveyStartDate}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'surveyEndDate'}>조회종료일</Label>
              <FlexWrapper>
                <Input
                  placeholder="YYYYMMDD"
                  id="surveyEndDate"
                  name="surveyEndDate"
                  type='date'
                  value={searchData.surveyEndDate}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>

            <FormGroup>
              <Label htmlFor={'isAnonymous'}>익명여부</Label>
              <Select
                id="isAnonymous"
                name="isAnonymous"
                width="120px"
                onChange={handleInputChange}
                value={searchData.isAnonymous}
              >
                <option value="">전체</option>
                {getComCodes('IS_ANONYMOUS').map((item) => (
                  <option key={'isAnonymous'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'isMultiple'}>다중선택여부</Label>
              <Select
                id="isMultiple"
                name="isMultiple"
                width="120px"
                onChange={handleInputChange}
                value={searchData.isMultiple}
              >
                <option value="">전체</option>
                {getComCodes('IS_MULTIPLE').map((item) => (
                  <option key={'isMultiple'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'useYn'}>사용여부</Label>
              <Select
                id="useYn"
                name="useYn"
                width="120px"
                onChange={handleInputChange}
                value={searchData.useYn}
              >
                <option value="">전체</option>
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label htmlFor={'delYn'}>삭제여부</Label>
              <Select
                id="delYn"
                name="delYn"
                width="100px"
                onChange={handleInputChange}
                value={searchData.delYn}
              >
                <option value="">전체</option>
                {getComCodes('DEL_YN').map((item) => (
                  <option key={'delYn'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label htmlFor={'surveyTitle'}>
                <></>
              </Label>
              <FlexWrapper>
                <Input
                  placeholder="투표제목"
                  width="300px"
                  id="surveyTitle"
                  name="surveyTitle"
                  maxLength={100}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <FlexWrapper gap="10px">
                <Button
                  onClick={handleSearch}
                  color="neverbe"
                  variant="outlined"
                >
                  검색
                </Button>
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <FlexWrapper gap="10px">
                <Button
                  onClick={() => {
                    navigate('/survey/insert', {});
                  }}
                  color="neverbe"
                >
                  등록
                </Button>
              </FlexWrapper>
            </FormGroup>
          </div>
        </div>
      </div>
      <DataTable
        columns={columns}                                     // 컬럼정보(header)
        data={data}                                           // 화면에 표시될 데이터
        pagination={true}                                     // 페이징 여부
        paginationRowsPerPageOptions={[10, 20, 30, 50]}       // 한화면에 보여줄 데이터 셀렉트박스
        sortIcon={<></>}                                      // 정렬아이콘 공백처리
        noDataComponent={<>조회결과가 없습니다.</>}
      />
    </>
  )
}
export default ComSurvey
